import { IconArrowOpenDownLine } from "@instructure/ui";
import { $isCodeNode, getCodeLanguages } from "@lexical/code";
import { $getNodeByKey } from "lexical";
import { useCallback, useMemo } from "react";

export const CodeLanguagePlugin = ({
  editor,
  codeLanguage,
  selectedElementKey,
}) => {
  const codeLanguages = useMemo(() => getCodeLanguages(), []);

  const onCodeLanguageSelect = useCallback(
    (e) => {
      editor.update(() => {
        if (selectedElementKey !== null) {
          const node = $getNodeByKey(selectedElementKey);
          if ($isCodeNode(node)) {
            node.setLanguage(e.target.value);
          }
        }
      });
    },
    [editor, selectedElementKey]
  );

  function Select({ onChange, className, options, value }) {
    return (
      <select
        id="code-language-select"
        className={className}
        onChange={onChange}
        value={value}
      >
        <option hidden={true} value="" />
        {options.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>
    );
  }

  return (
    <div className="code-select">
      <Select
        className="toolbar-item code-language"
        onChange={onCodeLanguageSelect}
        options={codeLanguages}
        value={codeLanguage}
      />
      <div className="down-arrow">
        <IconArrowOpenDownLine size="x-small" />
      </div>
    </div>
  );
};
